<template>
    <li
        v-if="basketLink !== null"
        class="order-medium-5 order-large-1"
    >
        <a
            :href="basketLink.Url"
            :alt="basketLink.Alt"
            :class="classes"
            class="no-padding"
            data-test="proposal-basket-icon-link"
        >
            <span class="button small white margin">
                <span
                    :data-clickaction="'click-header ' + websiteType"
                    data-clickcategory="header"
                    data-clicklabel="Basket"
                    class="icon-basket"
                />
                <span
                    v-show="basketCount > 0"
                    :data-clickaction="'click-header ' + websiteType"
                    data-clickcategory="header"
                    data-clicklabel="Basket"
                    class="badge"
                    v-html="basketCount"
                />
            </span>

        </a>
    </li>
</template>
<script>
export default {
    name: 'BasketElement',
    props: {
        basketCount: {
            type: Number,
            default() {
                return 0;
            }
        },
        classes: {
            type: Object,
            default() {
                return {};
            }
        },
        basketLink: {
            type: Object,
            default() {
                return {};
            },
            required: true
        },
        websiteType: {
            type: String,
            default() {
                return '';
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../header';

</style>
